var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestInRounded2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1743_81539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_1743_81539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6472 31.753C35.1936 32.292 35.1936 33.1738 34.6472 33.7128C34.1112 34.2415 33.25 34.2415 32.714 33.7128L30.0406 31.0757V40.9996C30.0406 41.7728 29.4138 42.3996 28.6406 42.3996C27.8674 42.3996 27.2406 41.7728 27.2406 40.9996V31.0757L24.5672 33.7128C24.0312 34.2415 23.17 34.2415 22.634 33.7128C22.0876 33.1738 22.0876 32.292 22.634 31.753L28.6406 25.8281L34.6472 31.753Z",
    fill: "#E87A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.01 40.9018C17.6093 41.5126 16.8051 41.7106 16.1666 41.3556L9.59922 37.7044C8.75922 37.152 8.19922 36.3234 8.19922 35.3568V18.5091C8.19922 17.5425 8.75922 16.5758 9.59922 16.1615L23.5992 8.0139C24.0192 7.7377 24.4392 7.59961 24.9992 7.59961C25.5592 7.59961 25.9792 7.7377 26.3992 8.0139L40.3992 16.1615C41.2392 16.7139 41.7992 17.5425 41.7992 18.5091V25.5329C41.7992 26.3061 41.1724 26.9329 40.3992 26.9329C39.626 26.9329 38.9992 26.3061 38.9992 25.5329V18.5091L24.9992 10.3615L10.9992 18.5091V35.3568L17.5124 38.9132C18.2272 39.3035 18.4567 40.2208 18.01 40.9018Z",
    fill: "url(#paint1_linear_1743_81539)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1743_81539",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1743_81539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1743_81539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1743_81539",
    x1: 49,
    y1: 25,
    x2: 0.999998,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1743_81539",
    x1: 41.7992,
    y1: 24.7925,
    x2: 8.19922,
    y2: 24.7925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1245"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestInRounded2);
export default __webpack_public_path__ + "static/media/RequestInRounded2.0153cb6dda46121d0c67f5c6fa72d582.svg";
export { ForwardRef as ReactComponent };